import { useCallback, useEffect, useRef } from 'react'

export function useCancellableRequest() {
  const requestIdRef = useRef(0)
  const abortControllerRef = useRef<AbortController | null>(null)

  useEffect(() => {
    return () => abortControllerRef.current?.abort()
  }, [])

  const start = useCallback(() => {
    const requestId = ++requestIdRef.current
    const controller = new AbortController()
    abortControllerRef.current = controller
    return { signal: controller.signal, isCurrent: () => requestId === requestIdRef.current }
  }, [])

  const cancel = useCallback(() => {
    requestIdRef.current++
    abortControllerRef.current?.abort()
  }, [])

  return { start, cancel }
}
